<template>
	<Alert :showClose="false"  @close="$emit('close')">
		<div class="content">
			<div class="warningTitle ">
				<img class="icon" src="../assets/icons/question.svg" />
				<p>{{ $t('finishOrder') }}</p>
				<p class="noReembolsosDevoluciones">{{ $t('NoReembolsosNiDevoluciones') }}</p>
			</div>
			<div>
				<div class="buttonContainer">
					<AjaxButton
						:text="$t('Rechazar')"
						@click="$emit('close')"
						style="color: white; background-color: #fff; font-weight: bold;"
						class="buttonCancel"
					></AjaxButton>
					<AjaxButton
						:text="$t('accept')"
						@click="$emit('click')"
						style="color: white; background-color: #fff; font-weight: bold;"
						class="buttonAccept"
					></AjaxButton>
				</div>
			</div>
		</div>
	</Alert>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Alert from '@/components/Alert.vue'
import AjaxButton from '@/components/AjaxButton.vue'

@Component({
	components: {
		Alert,
		AjaxButton
	}
})
export default class DoubleConfirmFinishOrder extends Vue {}
</script>
<style lang="scss" scoped>
p {
	margin: 0;
}
.content {
	font-size: 16px;
	font-weight: bold;
	color: #646979;
	font-stretch: condensed;
}

.caption {
	display: compact;
	padding: 10px;
	text-align: center;
}

.warningTitle {
	padding: 5%;
	background-color: #fdb947;
	color: white;
	font-size: 20px;
	text-align: center;
	font-weight: bold;
	img {
		max-width: 100%;
		width: 30%;
		margin-left: auto;
		margin-right: auto;
		display: block;
	}
	.noReembolsosDevoluciones {
		font-size: 10px;
        margin-top: 0.8em ;
	}
	div {
		display: flex;
		justify-content: center;
		align-items: center;
		.terminos {
			font-size: 11px;
			display: inline-block;
			a {
				color: #0e2348;
			}
		}
	}
}

.icon {
	margin-bottom: -1%;
	padding-right: 4px;
	width: 28px;
}
.buttonContainer {
	display: flex;
	justify-content: flex-start;
	padding: 5%;
	.buttonAccept {
		height: 35px;
		width: 100px;
		margin: auto;
		margin-bottom: 5%;
	}
	.buttonCancel {
		height: 35px;
		width: 100px;
		margin: auto;
		margin-bottom: 5%;
	}
}
</style>
